import { render } from "./NatalChart.vue?vue&type=template&id=65dc404a&scoped=true"
import script from "./NatalChart.vue?vue&type=script&lang=js"
export * from "./NatalChart.vue?vue&type=script&lang=js"

import "./NatalChart.vue?vue&type=style&index=0&id=65dc404a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dc404a"]])

export default __exports__